<template>
  <div>
    <h2 v-if="obData.messages" class="def-header-2">{{ result.messages.title }}</h2>
    <div class="stocks__grid">
      <StocksCard
        v-for="(item, i) in obData.items"
        :key="i"
        :result="item"
        :messages="obData.messages"
      />
    </div>
    <Pagination :result="obData.pagination" @triggerGetPage="getPage" @triggerAddMore="addMore" />
  </div>
</template>

<script>
import StocksCard from '@components/Stocks/StocksCard/StocksCard.vue';
import Pagination from '@components/bootstrap/Pagination.vue';

export default {
  name: 'Stocks',
  components: { Pagination, StocksCard },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      obData: this.result,
    };
  },
  methods: {
    /**
     * Тут происходит склеивание данных успешного ответа Ajax запроса
     */
    compareResponse(response) {
      const { data } = response;

      if (this.debug) {
        console.log('ajaxResponse', response);
      }

      for (const key in data.items) {
        this.obData.items.push(data.items[key]);
      }

      this.obData.pagination = data.pagination;
    },
    /**
     * Имитация перехода на нужную страницу
     */
    replaceResponse(response) {
      this.obData = response.data;
    },
    replaceItems(response) {
      this.obData.items.forEach((item, i) => {
        if (!response.data.items.find((el) => el.id == item.id)) {
          delete this.obData.items[i];
        }
      });
    },
    /**
     * Метод по которому происходит Ajax загрузка данных (добавление)
     */
    addMore() {
      if (this.obData.pagination.pageCount > this.obData.pagination.pageNumber) {
        axios
          .get(window.location.href, {
            params: {
              api: 'y',
              [this.obData.pagination.pagingKey]: ++this.obData.pagination.pageNumber,
            },
          })
          .then(this.compareResponse)
          .catch((error) => {
            console.log(error);
          })
          .then(() => {
            console.log('always executed');
          });
      }
    },
    /**
     * Метод по которому происходит Ajax переход на нужную страницу
     * @param numb
     */
    getPage(url) {
      axios
        .get(url, {
          params: {
            api: 'y',
          },
        })
        .then(this.replaceResponse)
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
.stocks {
  &__grid {
    display: grid;
    grid-row-gap: 24px;
    @include point-md {
      grid-row-gap: 40px;
    }
  }
}
</style>
